import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import SelectionButton from './_selection-button.js'
import KeyValueMap from './_key-value-map.js'

export default {
  name: 'Market',
  values: {
    direction: 'row',
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexBasis: '100%',
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          justifyContent: 'center',
          height: '28px',
          flexGrow: 0,
        },
      },
    },
    headerLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
        container: {
          flexGrow: 0,
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    defaultNumberOfSelectionGroups: 1,
    selectionsGroupContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          flexBasis: '0%',
          minWidth: '0px',
        },
      },
    },
    selectionButton: {
      configSet: SelectionButton,
      configValues: {
        view: {
          layoutDirection: 'horizontalAlignLeft',
          _mobile_layoutDirection: 'vertical',
          showSetGameInfoText: false,
        },
      },
    },
    showUnavailablePlaceholder: false,
    unavailableMarketContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    unavailableMarketText: {
      configSet: Text,
      configValues: {},
    },
    selectionLayoutOverrides: {
      configSet: KeyValueMap,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
